'use client';

import { type FC } from 'react';
import { Activities, Card } from '@/_components';
import type { ActivitiesPreviewTabProps } from './ActivitiesPreviewTab.types';

export const ActivitiesPreviewTab: FC<ActivitiesPreviewTabProps> = ({
  questionnaire,
}) => {
  return (
    <Card>
      <Activities
        type="questionnaire_related"
        enablePagination={true}
        companyId={questionnaire.company_id}
        questionnaireId={questionnaire.id}
      />
    </Card>
  );
};
